module.exports = __webpack_public_path__ + "static/media/market-img2.f0e3120f.png";